import axios from '../axios/axios';

export function getTrustHourlyApi(params) {
  return axios.post('/stats/trusthourly', params);
}

export function getTrustDailyApi(params) {
  return axios.post('/stats/trustdaily', params);
}
